'use client'

import { Button } from '@acko/button'
import { Typography } from '@acko/typography'
import { useEffect, useState } from 'react'

interface StickyFooterClientProps {
  onCheckPriceClick: () => void
}

export const StickyFooterClient = ({ onCheckPriceClick }: StickyFooterClientProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    const handleScroll = () => {
      const currentScrollY = window.scrollY
      const triggerElement = document.getElementById('mobile-sticky-footer-trigger')

      if (triggerElement && isMobile) {
        const triggerTop = triggerElement.offsetTop - 100
        const hasScrolledPastTrigger = currentScrollY > triggerTop
        const isScrollingDown = currentScrollY > lastScrollY
        const scrollDelta = Math.abs(currentScrollY - lastScrollY)

        const documentHeight = document.documentElement.scrollHeight
        const windowHeight = window.innerHeight
        const scrolledToBottom = currentScrollY + windowHeight >= documentHeight - 200

        if (scrolledToBottom) {
          setIsVisible(false)
        } else if (hasScrolledPastTrigger && isScrollingDown && scrollDelta > 5) {
          setIsVisible(true)
        } else if (!isScrollingDown && scrollDelta > 5) {
          setIsVisible(false)
        }
      }

      setLastScrollY(currentScrollY)
    }

    if (isMobile) {
      window.addEventListener('scroll', handleScroll, { passive: true })
      return () => {
        window.removeEventListener('scroll', handleScroll)
        window.removeEventListener('resize', checkMobile)
      }
    }

    return () => window.removeEventListener('resize', checkMobile)
  }, [lastScrollY, isMobile])

  if (!isMobile) {
    return null
  }

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 bg-white border-t border-[var(--color-border)] z-50 lg:hidden transform transition-transform duration-300 ease-in-out ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{
        boxShadow: '0 -2px 12px rgba(0, 0, 0, 0.1)',
      }}>
      <div className="px-16 md:px-32 py-12 flex items-center justify-between gap-12">
        <div className="flex-1">
          <Typography variant="body-md" weight="semibold" color="primary" className="leading-tight">
            Get your bike insurance quote
          </Typography>
          <Typography variant="body-sm" color="secondary" className="leading-tight">
            Starting at ₹457/year*
          </Typography>
        </div>
        <Button type="button" variant="primary" size="md" className="shrink-0 px-20 py-8" onClick={onCheckPriceClick}>
          Get Quote
        </Button>
      </div>
    </div>
  )
}
